import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import {
  LoggerService,
  SiteConnector,
  SiteContextActions,
  SiteContextSelectors,
  StateWithSiteContext,
  WindowRef,
  tryNormalizeHttpError
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { bufferCount, catchError, exhaustMap, filter, map, tap } from 'rxjs/operators'

@Injectable()
export class EbLanguageEffects {
  protected logger = inject(LoggerService)

  constructor(
    private readonly actions$: Actions,
    private readonly siteConnector: SiteConnector,
    private readonly state: Store<StateWithSiteContext>,
    private readonly windowRef: WindowRef
  ) {}

  loadLanguages$: Observable<
    SiteContextActions.LoadLanguagesSuccess | SiteContextActions.LoadLanguagesFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteContextActions.LOAD_LANGUAGES),
      exhaustMap(() => {
        return this.siteConnector.getLanguages().pipe(
          map(languages => new SiteContextActions.LoadLanguagesSuccess(languages)),
          catchError(error =>
            of(new SiteContextActions.LoadLanguagesFail(tryNormalizeHttpError(error, this.logger)))
          )
        )
      })
    )
  )

  activateLanguage$: Observable<SiteContextActions.LanguageChange> = createEffect(() =>
    // pipe on languagesState instead of currentLanguage to trigger also same languages
    this.state.select(SiteContextSelectors.getLanguagesState).pipe(
      bufferCount(2, 1),

      // avoid dispatching `change` action when we're just setting the initial value:
      filter(([previous]) => !!previous),
      map(
        ([previous, current]) =>
          new SiteContextActions.LanguageChange({
            previous: previous.activeLanguage,
            current: current.activeLanguage
          })
      )
    )
  )

  setActiveLanguage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(SiteContextActions.SET_ACTIVE_LANGUAGE),
        tap((payload: any) => {
          this.windowRef.localStorage.setItem('language', payload.payload)
        })
      )
    },
    { dispatch: false }
  )
}
